const easeOutSine = (
  elapsed: number,
  initialValue: number,
  amountOfChange: number,
  duration: number
): number =>
  amountOfChange * Math.sin(elapsed / duration * (Math.PI / 2)) + initialValue

export { easeOutSine }
